jQuery(document).ready(function ($) {

    let home_win;
    let draw;
    let away_win;

    $('.edit-post-button').click(function () {
        let title = $('#title-create-post');
        title.siblings("p").find('span').html(title.val().length);
        let container = $(".edit-post-modal");
        container.removeClass('d-none');
        container.find('.errors').html('');
        $('body').addClass('disable-scroll');
    })
    $('.edit-post-modal .icon-close').click(function () {
        $(this).parents('.edit-post-modal').addClass('d-none');
        $('body').removeClass('disable-scroll');
    })
    $(document).mouseup(function (e) {
        let container = $(".edit-post-modal");
        if (container.length && !container.hasClass('d-none')) {
            container = container.find('form');

            if (!container.is(e.target) && container.has(e.target).length === 0) {
                let header = $("header");
                let modul_page = $(".module-page");
                let footer = $("footer");
                if (header.is(e.target) || header.has(e.target).length > 0 ||
                    modul_page.is(e.target) || modul_page.has(e.target).length > 0 ||
                    footer.is(e.target) || footer.has(e.target).length > 0) {
                    $(".edit-post-modal").addClass('d-none');
                    $(".edit-post-modal").find('.errors').html('');
                    $('body').removeClass('disable-scroll');
                }
            }
        }
        $('.statistic-input-on-edit label').on('click', function () {
            $('.statistic-input-on-edit label').removeClass('selected');
            let input = $(this).find('input');
            input.attr('checked', true);
            $(this).addClass('selected');
        });
    });

    $(".edit-post-modal form").on('submit', function (e) {
        let errors = [];
        $(this).find('button.add-disable').prop("disabled", true);

        if ($(this).find('input#title-create-post').val().length === 0) {
            errors.push('Tittel er obligatorisk.');
        }

        if ($(this).find('select[name=cpt_category]').val() === null) {
            errors.push('Kategori er obligatorisk.');
        }

        if ($(this).find('#content-post').val() === '') {
            errors.push('Beskrivelse er obligatorisk.');
        }

      
        if (!$(this).find('.tips-content').hasClass('d-none')) {
            if ($(this).find('#country-create-post').val() === '')
                errors.push('Land er obligatorisk.');

            if ($(this).find('#league-create-post').val() === '')
                errors.push('Liga er obligatorisk.');

            if ($(this).find('#match-athletes-create-post').val() === '')
                errors.push('Kamp/utøver er obligatorisk.');

            if ($(this).find('#tip-outcome-create-post').val() === '')
                errors.push('Tips/utfall er obligatorisk.');

            if ($(this).find('#game-stop-create-post').val() === '')
                errors.push('Dato er obligatorisk.');

            if ($(this).find('#odds-create-post').val() === '')
                errors.push('Odds er obligatorisk.');

            if ($(this).find('#stake-create-post').val() === '')
                errors.push('Innsats er obligatorisk.');

            if ($(this).find('#company-create-post option:selected').val() === '') {
                errors.push('Bookmaker er obligatorisk.');
            }
        }

        if (errors.length > 0) {
            let errorsDiv = $(this).find('.errors');
            errorsDiv.html('');
            errors.map(item => {
                errorsDiv.append('<p>' + item + '</p>');
            });
            e.preventDefault();
            $(this).find('button.add-disable').prop("disabled", false);
            return false;
        }

        $(this).find('button.add-disable').prop("disabled", false);
        return true;
    });

    // $(window).on("load", function () {

    //     let match_id = ($('input#match_id').val());
        
    //     if(!(match_id === undefined || match_id === null)){
    //         $.ajax({
    //             url: "/wp-json/oddsnet/v1/proxy/events/" + match_id,
    //             dataType: 'json',
    //             success: function (response) {
    //                 let competitors = response.name;
    //                 let date = new Date(response.start_date);
    //                 let formattedDate = ("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + " " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
    //                 let match_status = response.status.name;
    //                 $(".match-date").html('<span>' + formattedDate + '</span>');
    //                 if (match_status == 'Finished' || match_status == 'Finished AP' || match_status == 'Finished ET') {
    //                     $('.event-title').addClass('info-match').text(competitors + " - " + '"Kampen er ferdig"');
    //                 } else if (match_status == 'Not started') {
    //                     $('.event-title').addClass('info-match').text(competitors + " - " + '"Kampen har startet"');
    //                 } else {
    //                     $('.match-information-status').addClass('info-match').text("Ikke startet");
    //                 }
    //             },
    //             error: function (req, status, err) {
    //             }
    //         });
    //     }
        
    //     if(!(match_id === undefined || match_id === null)){
    //         $.ajax({
    //             url: "/wp-json/oddsnet/v1/proxy/events/" + match_id + "/odds/1x2/?providers=betinia,1bet,vulkanbet,stake,bcgame",
    //             dataType: 'json',
    //             success: function (response) {
    //                 $.each(response, function (index) {
    //                     draw = ((this.offers[0].offer_type == "X" ? this.offers[0].odds : '') || ((this.offers[1].offer_type == "X" ? this.offers[1].odds : '')) || ((this.offers[2].offer_type == "X" ? this.offers[2].odds : '')));
    //                     home_win = ((this.offers[1].offer_type == "1" ? this.offers[1].odds : '') || (this.offers[2].offer_type == "1" ? this.offers[2].odds : '') || (this.offers[0].offer_type == "1" ? this.offers[0].odds : ''));
    //                     away_win = ((this.offers[2].offer_type == "2" ? this.offers[2].odds : '') || (this.offers[1].offer_type == "2" ? this.offers[1].odds : '') || (this.offers[0].offer_type == "2" ? this.offers[0].odds : ''));
    //                     $('.home_odds_win').eq(index).html(home_win);
    //                     $('.odds_draw').eq(index).html(draw);
    //                     $('.away_odds_win').eq(index).html(away_win);
    //                 });
    //             },
    //             complete: function () {
    //                 $('.load-gif').hide();
    //             },
    //             error: function (req, status, err) {
    //             }
    //         });
    //     }

    //     let all_modules = Array.prototype.slice.call(document.querySelectorAll('.sports-data-container'));
    //     all_modules.forEach((module) => {
    //         // Update last updated to page load time.
    //         current = new Date();
    //         if (module.querySelector('.last-updated span')) {
    //             module.querySelector('.last-updated span').textContent = current.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    //         }
    //     })

    // });

});